const Diamond = () => <span className="mt-[0.6em] h-2 w-2 shrink-0 rotate-45 bg-[#D4AF37]" />;
const P = "text-base leading-[1.85] text-[#0F3D39] md:text-lg";

const RENDER = {
  lead: (v) => <p className="font-display text-xl font-semibold leading-snug text-[#0D9488] md:text-2xl">{v}</p>,
  p: (v) => <p className={P}>{v}</p>,
  h: (v) => <h3 className="font-display pt-4 text-2xl font-bold tracking-tight text-[#0D9488]">{v}</h3>,
  pull: (v) => (
    <blockquote className="font-display my-6 border-l-2 border-[#D4AF37] py-1 pl-6 text-2xl font-semibold leading-snug tracking-tight text-[#0D9488] md:text-3xl">{v}</blockquote>
  ),
  lines: (v) => (
    <ul className="space-y-3 border-y border-[#E2ECEB] py-8">
      {v.map((l) => (
        <li key={l} className={`flex gap-4 ${P}`}>
          <Diamond />
          {l}
        </li>
      ))}
    </ul>
  ),
  bullets: (v) => (
    <div className="grid gap-4 sm:grid-cols-2">
      {v.map(([k, d]) => (
        <div key={k} className="border border-[#E2ECEB] bg-[#F4F9F8] p-6 transition-colors duration-300 hover:border-[#D4AF37]">
          <p className="font-display text-xs font-bold uppercase tracking-[0.22em] text-[#0D9488]">{k}</p>
          <p className="mt-3 text-base leading-relaxed text-[#0F3D39]">{d}</p>
        </div>
      ))}
    </div>
  ),
};

export const ArticleBody = ({ blocks }) => (
  <div className="space-y-7" data-testid="article-body">
    {blocks.map((b, i) => (
      <div key={i}>{RENDER[b.t](b.v)}</div>
    ))}
  </div>
);
